import type { RelatedTemplate } from "AdminPanel/Spine/store/configStore";

/**
 * 普通模版结合关联 Spine 组件时的 spine drawData（outfit）。
 *
 * 与 AdminPanel/Spine/lib/outfit.ts 的按模版聚合逻辑一致，但这里没有「主 Spine 模版」，
 * 只聚合已选中皮肤/染色所属的关联模版；动画附加到有 Spine 动画的关联模版上。
 * 返回结构：{ data: [{ templateId, skus, tonings, spineVersion?, animation? }] }
 */
export function buildAvatarSpineOutfit(
  relatedTemplates: RelatedTemplate[],
  selectedSkins: string[],
  selectedToningColors: Record<string, string>,
  currentAnimation?: string,
): { data: any[] } | null {
  const data = relatedTemplates
    .map((tpl) => {
      const skus = tpl.config?.skus || {};
      const skinNameToSku = new Map<string, any>();
      for (const [skuId, sku] of Object.entries(skus)) {
        const skuData = sku as any;
        if (skuData.skinName) {
          skinNameToSku.set(skuData.skinName, { id: skuId, ...skuData });
        }
      }

      const skuIds: string[] = [];
      const boundToningIds = new Set<string>();
      for (const skinName of selectedSkins) {
        const sku = skinNameToSku.get(skinName);
        if (sku) {
          skuIds.push(sku.id);
          (sku.toningIds || []).forEach((tid: string) => boundToningIds.add(tid));
        }
      }

      const tonings: Record<string, string> = {};
      for (const [toningId, colorSetId] of Object.entries(selectedToningColors)) {
        if (boundToningIds.has(toningId)) {
          tonings[toningId] = colorSetId;
        }
      }

      if (skuIds.length === 0 && Object.keys(tonings).length === 0) {
        return null;
      }

      const templateData: any = {
        templateId: tpl.id,
        skus: skuIds,
        tonings,
      };

      if (tpl.spineVersion != null && Number.isFinite(tpl.spineVersion)) {
        templateData.spineVersion = tpl.spineVersion;
      }

      // 仅带 Spine 动画数据的关联模版附加动画
      if (currentAnimation && tpl.spineData) {
        templateData.animation = currentAnimation;
      }

      return templateData;
    })
    .filter((d) => d !== null);

  if (data.length === 0) return null;
  return { data };
}
